class EventRoot {
    _events = {};

    $emit(event, ...args) {
        if (this._events[event]) {
            this._events[event].forEach((callback) => {
                try {
                    callback(...args);
                } catch (error) {
                    console.error(`Error in event handler for ${event}:`, error);
                }
            });
        }
    }

    $on(event, callback) {
        if (!this._events[event]) {
            this._events[event] = [];
        }
        this._events[event].push(callback);
    }

    $off(event, callback) {
        if (!this._events[event]) return;

        if (callback) {
            const index = this._events[event].indexOf(callback);
            if (index > -1) {
                this._events[event].splice(index, 1);
            }
        } else {
            delete this._events[event];
        }
    }
}

export const eventRoot = new EventRoot();
